import { createContext, useCallback, useContext, useState } from "react";

const ConfirmCtx = createContext(null);

export function ConfirmProvider({ children }) {
  const [opts, setOpts] = useState(null);
  const [resolver, setResolver] = useState(null);

  const confirm = useCallback((options) => {
    return new Promise((resolve) => {
      setOpts({
        title: "Are you sure?",
        message: "",
        confirmLabel: "Delete",
        cancelLabel: "Cancel",
        destructive: true,
        ...options,
      });
      setResolver(() => resolve);
    });
  }, []);

  const close = (result) => {
    if (resolver) resolver(result);
    setResolver(null);
    setOpts(null);
  };

  return (
    <ConfirmCtx.Provider value={confirm}>
      {children}
      {opts && (
        <div
          className="confirm-backdrop"
          onClick={() => close(false)}
          data-testid="confirm-backdrop"
        >
          <div
            className="confirm-card"
            onClick={(e) => e.stopPropagation()}
            data-testid="confirm-dialog"
          >
            <div className="confirm-title">{opts.title}</div>
            {opts.message && <div className="confirm-message">{opts.message}</div>}
            <div className="confirm-actions">
              <button
                className="confirm-cancel"
                onClick={() => close(false)}
                data-testid="confirm-cancel"
                autoFocus
              >
                {opts.cancelLabel}
              </button>
              <button
                className={opts.destructive ? "confirm-destructive" : "confirm-primary"}
                onClick={() => close(true)}
                data-testid="confirm-ok"
              >
                {opts.confirmLabel}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmCtx.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmCtx);
  if (!ctx) throw new Error("useConfirm must be used inside <ConfirmProvider>");
  return ctx;
}
